module.exports = __webpack_public_path__ + "img/sg_feature4.ab9457a5.jpg";